import "./styles.scss";
import RouteWithTitle from "../../Components/Navigation/AppRoute/RouteWithTitle";
import { withRouter } from "react-router-dom";
import { Notifier } from "../../Components/UI";
import React, { PureComponent } from "react";
import { Avatar, Typography } from "@mui/material";
import Check from "@mui/icons-material/Check";
import { styled } from "@mui/material/styles";

import Step from "@mui/material/Step";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import Stepper from "@mui/material/Stepper";
import StepLabel from "@mui/material/StepLabel";
import ScrollToTop from "../../Utils/ScrollToTop";

const stepperRoutEnum = {
  "/register": 0,
  "/register/basic": 1,
  "/register/advance": 1,
  "/register/profile": 2,
};

const steps = [
  {
    label: "Register & Verify",
  },
  {
    label: "Complete Your Profile",
  },
  {
    label: "Upload Photos",
  },
];

const QontoConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 20,
    left: "calc(-50% + 24px)",
    right: "calc(50% + 24px)",
  },
  [`&.${stepConnectorClasses.active}, &.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: { backgroundColor: "#0f766e" },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    borderRadius: 2,
    backgroundColor: "#d5dbe6",
  },
}));

const QontoStepIconRoot = styled("div")(({ ownerState }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: 40,
  height: 40,
  borderRadius: "50%",
  fontWeight: 700,
  fontSize: 16,
  backgroundColor: "#e8ecf4",
  color: "#6b7385",
  transition: "all .2s",
  ...(ownerState.active && {
    background: "linear-gradient(135deg, #4f46e5, #7c3aed)",
    color: "#fff",
    boxShadow: "0 4px 12px rgba(79,70,229,.4)",
  }),
  ...(ownerState.completed && {
    backgroundColor: "#0f766e",
    color: "#fff",
  }),
}));

function QontoStepIcon(props) {
  const { active, completed, className, icon } = props;
  return (
    <QontoStepIconRoot
      ownerState={{ active, completed }}
      className={className || ""}
    >
      {completed ? <Check fontSize="small" /> : icon}
    </QontoStepIconRoot>
  );
}

function CustomStepper(props) {
  const activeIndex = stepperRoutEnum[props.location.pathname] || 0;

  return (
    <Stepper
      alternativeLabel
      activeStep={activeIndex}
      connector={<QontoConnector />}
    >
      {steps.map((step) => (
        <Step key={step.label}>
          <StepLabel StepIconComponent={QontoStepIcon}>
            <Typography fontWeight={600} className="stepper-label">
              {step.label}
            </Typography>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}

class RegistrationLayout extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
    };
  }
  componentDidMount() {}

  render() {
    const { path, component, name } = this.props;

    return (
      <div className="registration-layout">
        <header className="reg-header">
          <Avatar
            alt="logo jspn"
            src={"/images/logo.webp"}
            onClick={() => {
              window.location.href = "/";
            }}
            sx={{ cursor: "pointer" }}
          />
          <Typography className="reg-title" fontWeight={700}>
            Create your account
          </Typography>
        </header>
        <div className="stepper_container">
          <CustomStepper {...this.props} />
        </div>
        <div className="content_container">
          <div className="container reg-content">
            {path && component && (
              <RouteWithTitle
                key={name}
                exact={true}
                path={path}
                component={component}
                name={name}
              />
            )}
          </div>
        </div>
        <Notifier />
        <ScrollToTop />
      </div>
    );
  }
}

export default withRouter(RegistrationLayout);
